import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="conditional-reveal"
export default class extends Controller {
  static outlets = ["reveal-with-disable-inputs"]

  subcontrollers() {
    return this.revealWithDisableInputsOutlets
  }

  update(event) {
    const newValue = event.target.value
    this.subcontrollers().forEach(subcontroller => {
      if (JSON.parse(subcontroller.element.dataset.showValues).includes(newValue)) {
        subcontroller.show()
      } else {
        subcontroller.hide()
      }
    })
  }
}
